import http from '@/utils/api2'

export function createAudit (bisId, bisKey, params) {
  if (typeof params !== 'string') {
    params = JSON.stringify(params)
  }
  return http.post(`/erp/common/audit/save`, { bisId, bisKey, params })
}

export function batchCreateAudit (bisKey, dataList) {
  dataList.forEach(item => {
    item.bisKey = bisKey
    if (typeof item.params !== 'string') {
      item.params = JSON.stringify(item.params)
    }
  })
  return http.post(`/erp/common/audit/save/batch`, dataList)
}

export function pass (ids) {
  return http.post(`/erp/common/audit/pass`, { ids: ids })
}
export function reject (ids) {
  return http.post(`/erp/common/audit/reject`, { ids: ids })
}
